import { FC, useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AssociateSetupContext } from '@vs-online-only-app/state';
import { CenteredCardView } from '@vs-online-only-app/ui';
import ProfileSetupViewBody from './ProfileSetupViewBody';
import { ProfileSetupProvider } from './ProfileSetupContext';
import ProfileSetupFooter from './ProfileSetupFooter';
import ProfileSetupLandingPage from './ProfileSetupLandingPage';

const ProfileStepperComponent: FC = () => (
  <ProfileSetupProvider>
    <CenteredCardView
      body={<ProfileSetupViewBody />}
      footer={<ProfileSetupFooter />}
    />
  </ProfileSetupProvider>
);

const ProfileSetupView: FC = () => {
  const [showLandingPage, setShowLandingPage] = useState(true);
  const { hasCompletedProfileSetup } = useContext(AssociateSetupContext);

  if (hasCompletedProfileSetup) {
    return <Navigate to="/" replace />;
  }
  if (showLandingPage) {
    return (
      <ProfileSetupLandingPage startStepper={() => setShowLandingPage(false)} />
    );
  }
  return <ProfileStepperComponent />;
};

export default ProfileSetupView;
